import { APPLICATION_STEPS } from 'src/constants';
import { get } from 'lodash';

export const isSuggestedStep = step => step && step.name === APPLICATION_STEPS.Suggested;

export const mapTalentPoolStatuses = (data, source_id) => {
  switch (source_id) {
    case 1:
      return get(data, 'state', 'interested');
    case 2:
      return 'interested';
    case 3:
      return get(data, 'promoter.name', 'interested');
    case 4:
      return 'recruited';
    default:
      return 'interested';
  }
};
